/**
 * @see https://github.com/vercel/next.js/discussions/18072#discussioncomment-109059
 */
export const pushRouterWithoutRerender = (url: string) => {
  window.history.pushState(
    { ...window.history.state, as: url, url: url },
    '',
    url,
  );
};
